var Countdown = function (selectorOrElement) {
    var $countdownEl;

    function init () {
        if (selectorOrElement) {
            $countdownEl = $(selectorOrElement);
        } else {
            $countdownEl = $(".js-countdown");
        }

        if ($countdownEl && $countdownEl.length > 0) {
            startTimer();
        }
    }

    function startTimer() {
        var eventTime = moment($countdownEl.data('date') || "19-06-2022 23:59:59", "DD-MM-YYYY HH:mm:ss").unix();
        var currentTime = moment().unix();
        var diffTime = eventTime - currentTime;
        var duration = moment.duration(diffTime * 1000, "milliseconds");
        var interval = 1000;

        // if time to countdown
        if (diffTime > 0) {
            var $days = $countdownEl.find(".js-countdown--days .js-countdown__int");
            var $hours = $countdownEl.find(".js-countdown--hours .js-countdown__int");
            var $mins = $countdownEl.find(".js-countdown--mins .js-countdown__int");
            var $secs = $countdownEl.find(".js-countdown--secs .js-countdown__int");

            setInterval(function() {
                duration = moment.duration(
                    duration.asMilliseconds() - interval,
                    "milliseconds"
                );

                // show how many days, hours, minutes and seconds are left
                $days.html(duration.days());
                $hours.html(duration.hours());
                $mins.html(duration.minutes());
                $secs.html(duration.seconds());
            }, interval);
        }
    }

    init();

    return $countdownEl;
}
